import { FC, ImgHTMLAttributes, useEffect, useRef } from "react";
import classNames from "classnames";

type ImageType = Omit<ImgHTMLAttributes<HTMLImageElement>, "src">;

interface LayziImageProps extends ImageType {
  classess?: string;
  dataSrc: string;
}

const LayziImage: FC<LayziImageProps> = ({ classess, dataSrc, ...rest }) => {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entries]: IntersectionObserverEntry[]) => {
        if (entries.isIntersecting && imageRef.current) {
          imageRef.current.src = dataSrc;
        }
      },
      { threshold: 1 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(imageRef.current);
      }
    };
  }, [dataSrc]);

  return (
    <img
      ref={imageRef}
      data-src={dataSrc}
      className={classNames(classess)}
      alt={rest.alt || "img"}
      {...rest}
    />
  );
};

export default LayziImage;
